import React from 'react';

export default function About() {
  return (
    <div style={{ 
      display: 'flex', 
      flexDirection: 'column', 
      minHeight: '100vh', // Forces the page to take up the full screen height
      backgroundColor: '#f8fafc',
      fontFamily: '"Inter", sans-serif' 
    }}>
      
      {/* Main Content Area */}
      <div style={{ 
        flex: '1', // Pushes the footer to the bottom if content is short
        maxWidth: '1200px', 
        width: '100%',
        margin: '0 auto', 
        padding: '80px 20px', 
        boxSizing: 'border-box'
      }}>
        <h2 style={{ fontSize: '2.5rem', fontWeight: '800', color: '#0c4a6e', marginBottom: '20px' }}>
          About Shabaaz Trading Co.
        </h2>
        <p style={{ fontSize: '1.1rem', lineHeight: '1.8', color: '#475569', marginBottom: '40px', maxWidth: '800px' }}>
          Established as a premier global supplier, Shabaaz Trading Co. specializes in sourcing and distributing heavy marine machinery, genuine spare parts, and deck equipment directly from primary shipbreaking yards and reputable manufacturers.
        </p>
        
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '30px' }}>
          <div style={{ padding: '30px', backgroundColor: '#ffffff', borderRadius: '12px', borderLeft: '5px solid #0284c7', boxShadow: '0 4px 20px rgba(15, 23, 42, 0.05)' }}>
            <h4 style={{ fontSize: '1.3rem', fontWeight: '700', color: '#0c4a6e', marginBottom: '12px' }}>Our Mission</h4>
            <p style={{ color: '#64748b', fontSize: '1rem', lineHeight: '1.6' }}>To supply top-tier, reliable maritime equipment globally while maintaining rigid safety, standard testing, and structural sustainability parameters.</p>
          </div>
          <div style={{ padding: '30px', backgroundColor: '#ffffff', borderRadius: '12px', borderLeft: '5px solid #38bdf8', boxShadow: '0 4px 20px rgba(15, 23, 42, 0.05)' }}>
            <h4 style={{ fontSize: '1.3rem', fontWeight: '700', color: '#0c4a6e', marginBottom: '12px' }}>Global Logistics</h4>
            <p style={{ color: '#64748b', fontSize: '1rem', lineHeight: '1.6' }}>Leveraging strategically placed distribution pipelines, we guarantee rapid international transit times directly to shipyards, docks, or storage points.</p>
          </div>
        </div>
      </div>

      {/* Professional Footer */}
      <footer style={{ 
        backgroundColor: '#0f172a', 
        color: '#94a3b8', 
        padding: '40px 20px', 
        marginTop: 'auto', // Ensures it stays at the absolute bottom
        borderTop: '1px solid #1e293b'
      }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto', display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between', gap: '30px' }}>
          <div>
            <h5 style={{ color: '#ffffff', fontSize: '1.1rem', fontWeight: '700', marginBottom: '10px' }}>Shabaaz Trading Co.</h5>
            <p style={{ fontSize: '0.9rem', maxWidth: '300px', lineHeight: '1.5' }}>Your trusted partner in global maritime machinery and heavy equipment supply.</p>
          </div>
          <div style={{ display: 'flex', gap: '50px' }}>
            <div>
              <h6 style={{ color: '#ffffff', fontWeight: '600', marginBottom: '12px', fontSize: '0.95rem' }}>Quick Links</h6>
              <ul style={{ listStyle: 'none', padding: 0, margin: 0, fontSize: '0.9rem', lineHeight: '2' }}>
                <li><a href="#home" style={{ color: '#94a3b8', textDecoration: 'none' }}>Home</a></li>
                <li><a href="#products" style={{ color: '#94a3b8', textDecoration: 'none' }}>Products</a></li>
                <li><a href="#contact" style={{ color: '#94a3b8', textDecoration: 'none' }}>Contact</a></li>
              </ul>
            </div>
            <div>
              <h6 style={{ color: '#ffffff', fontWeight: '600', marginBottom: '12px', fontSize: '0.95rem' }}>Contact Us</h6>
              <p style={{ fontSize: '0.9rem', margin: '0 0 8px 0' }}>Email: info@shabaaztrading.com</p>
              <p style={{ fontSize: '0.9rem', margin: 0 }}>Global Distribution Network</p>
            </div>
          </div>
        </div>
        <div style={{ maxWidth: '1200px', margin: '30px auto 0 auto', paddingTop: '20px', borderTop: '1px solid #1e293b', fontSize: '0.85rem', textAlign: 'center' }}>
          &copy; {new Date().getFullYear()} Shabaaz Trading Co. All rights reserved.
        </div>
      </footer>

    </div>
  );
}